import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { IonCard, IonCardContent, IonCardHeader, IonCardTitle } from '@ionic/react';
import { FaCalendarAlt } from 'react-icons/fa';
import './CierreDiario.css';
import api from 'src/services/api';

const CierreDiario = ({ retrieveData }: { retrieveData?: boolean }) => {
    const [todos, setTodos] = useState<any[]>([]);
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());
    const [noResults, setNoResults] = useState<boolean>();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            if (retrieveData) {
                const fechaHoyFormatted = selectedDate.toISOString().slice(0, 10);
                await obtenerDatos(fechaHoyFormatted);
            }
        })();
    }, [retrieveData])

    const obtenerDatos = async (date?: string) => {
        setLoading(true);
        try {
            const data = await api.get(`/cierre_diario/todos?fecha=${date}`);
            const informacion = await data.data.datos;
            if (informacion.length === 0) {
                setNoResults(true);
                setTodos([]);
                return;
            }
            setNoResults(false);
            setTodos(informacion);
        } catch (error) {
            setNoResults(true);
            console.error("Error al obtener datos:", error);
        } finally {
            setLoading(false);
        }
    };

    return (

        <div className='container' style={{ backgroundColor: '#FFF', flexDirection: 'column' }}>
            <div className="datePicker-container">
                <DatePicker
                    selected={selectedDate}
                    onChange={date => {
                        setSelectedDate(date);
                        if (date) {
                            const formattedDate = date.toISOString().substr(0, 10);
                            obtenerDatos(formattedDate);
                        }
                    }}
                    placeholderText="Año/Mes/Día"
                    dateFormat="yyyy-MM-dd"
                    className="custom-datepicker"
                    popperPlacement="bottom-end"
                />
                <FaCalendarAlt className="icon" style={{ color: '#910434' }} />
            </div>

            {/* Loader */}
            {loading && (
                <div style={{ textAlign: 'center', marginTop: '20px', color: '#910434' }}>
                    Cargando...
                </div>
            )}

            {noResults ? (
                <div className="container" style={{ flexDirection: 'column' }}>
                    <div className="folder">
                        <div className="top"></div>
                        <div className="bottom"></div>
                    </div>
                    <div className="title">No se han encontrado registros para la fecha solicitada</div>
                </div>
            ) : (
                todos.map((item, idx) => (
                    <IonCard key={idx} routerLink={`/CierreDiario/${item.ps_id}/${item.fecha}`}
                        style={{ textDecoration: 'none', width: "100%" }}>
                        <IonCardHeader style={{ backgroundColor: '#910434' }} >
                            <p style={{ color: '#ffffff', margin: '10px' }}>Fecha: {item.fecha}</p>
                            <IonCardTitle style={{ textAlign: 'center', color: '#ffffff', fontSize: '20px' }}>{item.ps_nombre}</IonCardTitle>
                        </IonCardHeader>

                        <IonCardContent style={{ display: 'flex', marginTop: '15px' }}>
                            <p>Código: {item.ps_codigo}</p>
                        </IonCardContent>

                        <IonCardContent style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                            <p style={{ color: '#910434', marginLeft: 'auto' }}>No corresponde Asignación: {item.cantidad}</p>
                        </IonCardContent>

                        <IonCardContent style={{ display: 'none' }}>
                            ID: {item.ps_id}
                        </IonCardContent>
                    </IonCard>
                ))
            )}
        </div>
    );
};

export default CierreDiario;
